import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=66d48c7d&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66d48c7d')) {
      api.createRecord('66d48c7d', component.options)
    } else {
      api.reload('66d48c7d', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=66d48c7d&", function () {
      api.rerender('66d48c7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/Button.vue"
export default component.exports